<template>
    <label :for="id" class="c-form_label" :class="{'-required': required}">
        {{ labelText }}
    </label>
    <select 
    class="c-form_input c-form_select_input" 
    :id="id" 
    :name="name" 
    :placeholder="placeholder" 
    :required="required"
    @change="$emit('update:modelValue', $event.target.value)"
    >
        <option value="" disabled selected>{{ placeholder }}</option>
        <option 
        v-for="option in options" :value="option.value"
        :selected="option.value === modelValue"
        >{{ option.text }}</option>
    </select>
    <div class="c-form_validation">
        <div class="c-form_validation_required">
            {{ _t("Enter a value for this field.") }}
        </div>
        <div class="c-form_validation_invalid">
            {{ _t("This field is invalid.") }}
        </div>
    </div>
</template>
<script>
export default {
    name: 'SelectInput',
    props: {
        id: {
            type: String,
            default: ''
        },
        value: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: ''
        },
        required: {
            type: Boolean,
            default: false
        },
        name: {
            type: String,
            default: ''
        },
        labelText: {
            type: String,
            default: ''
        },
        options: {
            type: Array,
            default: []
        },
        modelValue: {
            type: String,
            default: ''
        }
    },
    data() {
        return {

        }
    }
}
</script>